import { useRef } from "react";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Inject,
} from "@syncfusion/ej2-react-grids";
import { DataManager, WebApiAdaptor } from "@syncfusion/ej2-data";
import { Card } from "react-bootstrap";
import { storageKeys } from "../../../Constants/storage.key";
import { storage } from "../../../Services/storage.service";

function TableSyncExample() {
  
  const token = storage.get(storageKeys.access_and_token);
  const gridRef = useRef(null);

  const hostUrl =
    "https://nc8.olharfixo.com.br/Vehicles/api/v3/Vehicles/22599/positions/paged?isEvent=N";

  class CustomAdaptor extends WebApiAdaptor {
    processResponse(response) {
      
      const data = response.vehiclePositions ?? [];
      const count = response.totalPages ?? 0;

      return { result: data, count: count };
    }
  }

  const data = new DataManager({
    url: hostUrl,
    adaptor: new CustomAdaptor(),
    headers: [{ Authorization: `Bearer ${token.token}` }],
  });

  return (
    <Card>
      <div className="control-pane">
        <div className="control-section">
          <GridComponent
            id="Grid"
            dataSource={data}
            ref={gridRef}
            allowPaging={true}
            pageSettings={{ pageSize: 5 }}
          >
            <ColumnsDirective>
              <ColumnDirective
                field="vehicleId"
                headerText="ID"
                width="120"
                textAlign="Right"
              />
              <ColumnDirective
                field="generationDate"
                headerText="Data Geração"
                width="180"
              />
              <ColumnDirective
                field="location"
                headerText="Localização"
                width="250"
              />
              <ColumnDirective
                field="latitude"
                headerText="Latitude"
                width="150"
                textAlign="Right"
              />
              <ColumnDirective
                field="longitude"
                headerText="Longitude"
                width="150"
                textAlign="Right"
              />
              <ColumnDirective
                field="speed"
                headerText="Velocidade"
                width="120"
                textAlign="Right"
              />
              <ColumnDirective
                field="odometer"
                headerText="Odômetro"
                width="150"
                textAlign="Right"
              />
            </ColumnsDirective>
            <Inject services={[Page]} />
          </GridComponent>
        </div>
      </div>
    </Card>
  );
}

export default TableSyncExample;
